export default __webpack_public_path__ + "static/media/houseparty.dcc7bd61.svg";